import React from "react";

/**
 * Chaos Media Hub brand mark — the user-supplied stylized "M" PNG.
 * Same prop API as the previous SVG so every existing import keeps working.
 */
export const ChaosLogo = ({ size = 32, className = "" }) => (
  <img
    src="/icons/m_logo_192.png"
    width={size}
    height={size}
    alt="CMH logo"
    data-testid="chaos-logo"
    draggable={false}
    className={className}
    style={{ width: size, height: size, display: "block", userSelect: "none" }}
  />
);

export default ChaosLogo;
